
import { Options, Prop, Vue } from 'vue-property-decorator'

@Options({
  name: 'Play'
})
export default class Play extends Vue {
  @Prop({
    type: Boolean
  })
  readonly pause!: boolean
}
